import * as z from "zod";

export const merchantHasPricingTests = {
  name: "merchantHasPricingTests" as const,
  input: z.object({}),
  output: z.object({ hasPricingTests: z.boolean() }),
};
